import { Input, type GetProps } from 'antd';
import cs from 'classnames';
import Styles from './Styles.module.scss';

type TextAreaProps = GetProps<typeof Input.TextArea>;

export default function MPTextArea({ className, ...props }: IMPTextAreaProps) {
    return (
        <>
            <Input.TextArea
                className={cs(Styles?.MPTextAreaContainer, className)}
                {...props}
            />
        </>
    );
}

export interface IMPTextAreaProps extends TextAreaProps {}
